import { toImagesBlob } from '../lib/resolveImage'

export async function resolveHandler(image: HTMLImageElement, size: number): Promise<any> {
  return await (toImagesBlob(image, { type: 'image/jpeg' }, size))
}
